export default defineNuxtPlugin(() => {
  const route = useRoute();
  const checkPage = (targetPage: string): boolean => {
    return route.name === targetPage
  }
  return {
    provide: {
      checkPage
    },
  };
})
